import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { LayoutService } from '@shared/services';
import { HeaderConfig } from './models/header-config.model';

/**
 * Page header with the current page title, tagline, and company logo.
 */
@Component({
  selector: 'pulse-header',
  templateUrl: './pulse-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PulseHeaderComponent {
  layoutService = inject(LayoutService);
  config = input.required<HeaderConfig>();
}
